module.exports = __webpack_public_path__ + "static/media/item_sli_extend_des.0ce86253.png";